/**
 * AISearchTelemetry — Iter 341 · Feb 12, 2026
 * Component wrapper for the useAISearchTelemetry hook. Placed inside
 * <BrowserRouter> in App.js so it has access to useLocation.
 */
import useAISearchTelemetry from "@/hooks/useAISearchTelemetry";

export default function AISearchTelemetry() {
  useAISearchTelemetry();
  return null;
}
